import i18n from "@/i18n";
import { NAVBAR_PRIVILEGES_KEYS } from "../constants/constants";
import { privilegesService } from "./privilegesService";
class NavBarService {
    setNavigationListByPrivileges(navBarList) {
        const privileges = privilegesService.getPrivileges();
        if (privileges.length > 0) {
            for (const privilege of privileges) {
                if (NAVBAR_PRIVILEGES_KEYS[privilege]) {
                    const value = NAVBAR_PRIVILEGES_KEYS[privilege];
                    value.name = i18n.t(value.i18nKey);
                    navBarList.push(value);
                }
            }
        }
    }
}

export default new NavBarService();